import { bgAppCopy } from '@/i18n/catalogs/bg';
import { csAppCopy } from '@/i18n/catalogs/cs';
import { daAppCopy } from '@/i18n/catalogs/da';
import { deAppCopy } from '@/i18n/catalogs/de';
import { elAppCopy } from '@/i18n/catalogs/el';
import { esAppCopy } from '@/i18n/catalogs/es';
import { etAppCopy } from '@/i18n/catalogs/et';
import { fiAppCopy } from '@/i18n/catalogs/fi';
import { frAppCopy } from '@/i18n/catalogs/fr';
import { gaAppCopy } from '@/i18n/catalogs/ga';
import { hrAppCopy } from '@/i18n/catalogs/hr';
import { huAppCopy } from '@/i18n/catalogs/hu';
import { itAppCopy } from '@/i18n/catalogs/it';
import { ltAppCopy } from '@/i18n/catalogs/lt';
import { lvAppCopy } from '@/i18n/catalogs/lv';
import { mtAppCopy } from '@/i18n/catalogs/mt';
import { nlAppCopy } from '@/i18n/catalogs/nl';
import { plAppCopy } from '@/i18n/catalogs/pl';
import { ptAppCopy } from '@/i18n/catalogs/pt';
import { roAppCopy } from '@/i18n/catalogs/ro';
import { skAppCopy } from '@/i18n/catalogs/sk';
import { slAppCopy } from '@/i18n/catalogs/sl';
import type { EuAppLanguage } from '@/i18n/eu-locales';

export const englishAppCopy = {
  welcomeHeading: 'How can I help you today?',
  thinking: 'Thinking',
  scrollToBottom: 'Scroll to bottom',
  reasoning: 'Reasoning',
  reasoningInProgress: 'in progress',
  citationPages: 'Pages {first}–{last}',
  citationTitle: 'Source excerpt',
  citationLoading: 'Loading source…',
  citationUnavailable: 'This cited text is unavailable or you no longer have access.',
  citationOpen: 'Open source',
  citationCopied: 'Citation copied',
  copy: 'Copy',
  more: 'More',
  tryAgain: 'Try again',
  answerTruncated: 'The answer hit the length limit and was cut off.',
  continueAnswer: 'Continue the answer',
  exportMarkdown: 'Export as Markdown',
  edit: 'Edit',
  cancel: 'Cancel',
  update: 'Update',
  previous: 'Previous',
  next: 'Next',
  messagePlaceholder: 'Send a message…',
  projectHomePlaceholder: 'New chat in {project}',
  sharedChatEveryone: 'Everyone at {company} can read this chat',
  sharedChatOnePerson: '1 person can read this chat',
  sharedChatPeople: '{count} people can read this chat',
  forkedChatPlaceholder: 'Continue with your own connections…',
  newAnswer: 'New answer',
  messageInput: 'Message input',
  sendMessage: 'Send message',
  stopGenerating: 'Stop generating',
  addAttachment: 'Add attachment',
  removeFile: 'Remove file',
  attachmentPreview: 'Attachment preview',
  imageAttachmentPreview: 'Image attachment preview',
  image: 'Image',
  openLink: 'open link',
  document: 'Document',
  file: 'File',
  attachment: 'attachment',
  uploadFailed: 'upload failed',
  uploading: 'uploading',
  toolIncomplete: 'Incomplete',
  toolActivity: 'Activity',
  activityThinking: 'Thinking…',
  activityWriting: 'Writing…',
  activityWaiting: 'Waiting for your approval',
  activityStopped: 'Stopped',
  activityCouldNotFinish: "Couldn't finish",
  activitySources: 'sources',
  activityShowThinking: 'Show thinking',
  activityOpen: 'Open activity',
  activitySteps: 'Steps',
  activitySourcesTab: 'Sources',
  activityUnavailable: 'This activity is unavailable.',
  activityInput: 'Input',
  activityOutput: 'Output',
  activityNoSources: "This answer didn't cite any sources.",
  activityApprovedByReply: 'Approved by your reply',

  toolRunning: 'Working',
  toolComplete: 'Complete',
  toolNeedsApproval: 'Needs approval',
  toolInput: 'Input',
  toolCall: 'tool call',
  toolCalls: 'tool calls',
  openMenu: 'Open menu',
  closeMenu: 'Close menu',
  close: 'Close',
  showInTextField: 'Show in text field',
  settings: 'Settings',
  appearance: 'Appearance',
  themeLight: 'Light',
  themeDark: 'Dark',
  themeSystem: 'System',
  themeChoiceHelp: 'Applies on all your devices. System follows each device’s light or dark mode.',
  themeSaveFailed: 'We could not save your appearance, so it is unchanged. Please try again.',
  toolUsed: 'Used tool',
  toolCancelled: 'Cancelled tool',
  toolResult: 'Result:',
  toolError: 'Error:',
  toolCancelledReason: 'Cancelled reason:',
  approvalAllow: 'Allow',
  approvalAlwaysAllow: 'Always allow',
  approvalDeny: 'Deny',
  approvalAlwaysDeny: 'Always deny',
  approvalConfirm: 'Confirm',
  approvalBack: 'Back',
  approvalApprovedResult: 'Approved by user',
  approvalDeniedResult: 'User denied tool execution',
  logout: 'Log out',
  loginOrCreateAccount: 'Log in / Create account',
  newChat: 'New chat',
  untitledChat: 'Untitled chat',
  previousChats: 'Previous chats',
  openChat: 'Open chat {title}',
  moreActionsForChat: 'More actions for {title}',
  chatActions: 'Chat actions',
  closeChatActions: 'Close chat actions',
  deleteChatQuestion: 'Delete chat?',
  deleteChatDescription: 'The chat “{title}” will be permanently deleted.',
  deleteChat: 'Delete chat',
  keepChat: 'Keep chat',
  delete: 'Delete',
  deleting: 'Deleting…',
  chatDeleteFailed: 'The chat could not be deleted. Try again.',
  settingsDescription: 'Customize how the assistant works for you.',
  settingsDesktopDescription: 'Customize how the assistant responds to you.',
  personalization: 'Personalization',
  personalizationDescription: 'Customize the instructions the assistant follows in every answer.',
  languageAndRegion: 'Language and region',
  languageAndRegionDescription: 'Choose language and time zone.',
  memories: 'Memories',
  memoriesDescription: 'View, edit, or delete what the assistant remembers about you.',
  account: 'Account',
  accountDescription: 'Manage the account and permanent deletion of your data.',
  backToSettings: 'Back to settings',
  closeSettings: 'Close settings',
  settingsCategories: 'Settings categories',
  yourSettings: 'Your settings',
  dataAndAccount: 'Data and account',
  viewAndManageMemories: 'View and manage what the assistant remembers',
  loginToUseMemories: 'Log in to use memories',
  manageOrDeleteAccount: 'Manage or delete the account',
  unsavedChanges: 'You have unsaved changes',
  unsavedCloseDescription: 'Closing settings will discard the changes on this page.',
  unsavedBackDescription: 'Going back will discard the changes on this page.',
  continueEditing: 'Continue editing',
  discardChanges: 'Discard changes',
  saveChanges: 'Save changes',
  localSettingsNote: 'Saved in this browser. Log in to save to your account.',
  personality: 'Personality',
  personalityHelp: 'Custom instructions the assistant follows in every answer',
  personalityPlaceholder:
    'For example: Be concise and concrete. I live in Gothenburg and like vegetarian food.',
  timezone: 'Time zone',
  searchTimezone: 'Search time zones…',
  automaticBrowser: 'Automatic (browser)',
  saved: 'Saved {date}',
  addMemory: 'Add memory',
  newMemory: 'New memory',
  memoryPlaceholder: 'For example: I prefer short, concrete answers.',
  editMemory: 'Edit memory',
  saveMemory: 'Save memory',
  deleteMemory: 'Delete memory',
  memorySaveFailed: 'The memory could not be saved. Try again.',
  memoryLimitReached: 'You can save up to 50 memories. Delete one before adding another.',
  memoryInvalid: 'Memories cannot contain links. Remove the link and try again.',
  memoryDeleteFailed: 'The memory could not be deleted. Try again.',
  memoryLoadFailed: 'Memories could not be loaded.',
  loadingMemories: 'Loading memories…',
  emptyMemories:
    'The assistant saves memories about you while you talk — what you like, where you live, and what you do. You can view, edit, and delete them here.',
  deleteAccountHelp:
    'Permanently delete the account and all related chats, memories, and settings.',
  deleteAccount: 'Delete account',
  deleteAccountQuestion: 'Permanently delete the account?',
  deleteAccountDescription:
    'All chats, messages, memories, settings, and sign-in credentials will be deleted. This action cannot be undone.',
  deleteAccountConfirm: 'Yes, delete my account',
  accountDeleteFailed: 'The account could not be deleted. Nothing was removed — try again.',
  logoutEverywhereTitle: 'All devices',
  logoutEverywhereHelp:
    'Log out on every device and browser where your account is open, this one included.',
  logoutEverywhere: 'Log out everywhere',
  logoutEverywhereQuestion: 'Log out on all devices?',
  logoutEverywhereDescription:
    'You will need to log in again on every device and browser, this one included. Your chats and settings stay as they are.',
  loggingOut: 'Logging out…',
  logoutEverywhereFailed:
    'We couldn’t confirm that you were logged out everywhere. Try again, or check on another device whether you’re still logged in.',
  settingsSaveFailed: 'Settings could not be saved. Try again.',
  customInstructions: 'Custom instructions',
  notSet: 'Not set',
  automaticLanguage: 'Automatic language',
  automaticTimezone: 'automatic time zone',
  appLanguage: 'App language',
  appLanguageHelp:
    'Controls the entire app interface and dates. Assistant replies continue to follow the language you write in.',
  automaticBrowserLanguage: 'Automatic (browser language)',
  previousLanguageChoice: 'Previous choice: {language} ({locale})',
  previousLanguageChoiceCode: 'Previous choice ({locale})',
  canvasCopyLink: 'Copy link',
  canvasLinkCopied: 'Link copied',
  actionUpdatedWithEdits: 'Updated with your edits',
  activityStepsDone: 'one:step done|other:steps done',
  activityResultsCount: 'one:result|other:results',
  canvasCopyLinkFailed: "Couldn't copy the link",
  canvasOpenInAgent: 'Open in {agent}',
  canvasExpand: 'Expand',
  canvasExitFullView: 'Exit full view',
  webSourceUnread:
    "Linked in this answer. Poneva didn't read this page, so there's nothing to show here.",
  webSourceOpenOriginal: 'Open original',
  // DES1 HC-08: the chat tool cards' progress, error and next-step lines.
  toolProgressSettings: 'Changing your settings…',
  toolProgressAgent: 'Creating the agent…',
  toolProgressConnections: 'Finding connection options…',
  toolProgressResult: 'Preparing your result…',
  toolProgressClarification: 'Preparing a clarification…',
  toolProgressKnowledge: 'Preparing a suggested knowledge update…',
  toolProgressQuestion: 'Preparing a question for you…',
  toolProgressSkill: 'Shaping your Skill…',
  toolErrorSettings: 'Your settings were not changed.',
  toolErrorAgent: 'The agent could not be created.',
  toolErrorConnections: 'Connection options could not be loaded.',
  toolErrorResult: 'The result was not saved.',
  toolErrorClarification: 'The clarification could not be prepared.',
  toolErrorKnowledge: 'The suggested knowledge update could not be prepared.',
  toolErrorQuestion: 'The question could not be prepared.',
  toolErrorSkill: 'The Skill draft could not be saved.',
  toolErrorOpenSettings: 'Open Settings',
  toolErrorOpenAgents: 'Open Agents',
  toolErrorOpenConnections: 'Open Connections',
  toolStepIncomplete: 'This step did not complete.',
  // DES1 HC-10: failed attempts a later call of the same thing completed (formatCount forms).
  toolEarlierAttemptsFailed:
    'one:earlier attempt didn’t go through|other:earlier attempts didn’t go through',
} as const;

export type AppCopyKey = keyof typeof englishAppCopy;
export type AppCopy = Readonly<Record<AppCopyKey, string>>;

export const swedishAppCopy = {
  welcomeHeading: 'Hur kan jag hjälpa dig idag?',
  thinking: 'Tänker',
  scrollToBottom: 'Rulla längst ned',
  reasoning: 'Resonemang',
  reasoningInProgress: 'pågår',
  citationPages: 'Sidor {first}–{last}',
  citationTitle: 'Källutdrag',
  citationLoading: 'Hämtar källa…',
  citationUnavailable: 'Den citerade texten är inte tillgänglig eller så saknar du åtkomst.',
  citationOpen: 'Öppna källa',
  citationCopied: 'Källhänvisning kopierad',
  copy: 'Kopiera',
  more: 'Mer',
  tryAgain: 'Försök igen',
  answerTruncated: 'Svaret nådde längdgränsen och klipptes av.',
  continueAnswer: 'Fortsätt svaret',
  exportMarkdown: 'Exportera som Markdown',
  edit: 'Redigera',
  cancel: 'Avbryt',
  update: 'Uppdatera',
  previous: 'Föregående',
  next: 'Nästa',
  messagePlaceholder: 'Skriv ett meddelande…',
  projectHomePlaceholder: 'Ny chatt i {project}',
  sharedChatEveryone: 'Alla på {company} kan läsa den här chatten',
  sharedChatOnePerson: '1 person kan läsa den här chatten',
  sharedChatPeople: '{count} personer kan läsa den här chatten',
  forkedChatPlaceholder: 'Fortsätt med dina egna kopplingar…',
  newAnswer: 'Nytt svar',
  messageInput: 'Meddelandeinmatning',
  sendMessage: 'Skicka meddelande',
  stopGenerating: 'Stoppa svaret',
  addAttachment: 'Lägg till bilaga',
  removeFile: 'Ta bort fil',
  attachmentPreview: 'Förhandsvisning av bilaga',
  imageAttachmentPreview: 'Förhandsvisning av bildbilaga',
  image: 'Bild',
  openLink: 'öppna länk',
  document: 'Dokument',
  file: 'Fil',
  attachment: 'bilaga',
  uploadFailed: 'uppladdningen misslyckades',
  uploading: 'laddas upp',
  toolIncomplete: 'Ofullständigt',
  toolActivity: 'Aktivitet',
  activityThinking: 'Tänker…',
  activityWriting: 'Skriver…',
  activityWaiting: 'Väntar på ditt godkännande',
  activityStopped: 'Stoppad',
  activityCouldNotFinish: 'Kunde inte slutföra',
  activitySources: 'källor',
  activityShowThinking: 'Visa tänkande',
  activityOpen: 'Öppna aktivitet',
  activitySteps: 'Steg',
  activitySourcesTab: 'Källor',
  activityUnavailable: 'Den här aktiviteten är inte tillgänglig.',
  activityInput: 'Indata',
  activityOutput: 'Utdata',
  activityNoSources: 'Det här svaret citerade inga källor.',
  activityApprovedByReply: 'Godkänt genom ditt svar',
  toolRunning: 'Arbetar',
  toolComplete: 'Klart',
  toolNeedsApproval: 'Behöver godkännande',
  toolInput: 'Indata',
  toolCall: 'verktygsanrop',
  toolCalls: 'verktygsanrop',
  openMenu: 'Öppna meny',
  closeMenu: 'Stäng meny',
  close: 'Stäng',
  showInTextField: 'Visa i textfält',
  settings: 'Inställningar',
  appearance: 'Utseende',
  themeLight: 'Ljust',
  themeDark: 'Mörkt',
  themeSystem: 'System',
  themeChoiceHelp:
    'Gäller på alla dina enheter. System följer varje enhets ljusa eller mörka läge.',
  themeSaveFailed: 'Vi kunde inte spara utseendet, så inget har ändrats. Försök igen.',
  toolUsed: 'Använde verktyg',
  toolCancelled: 'Avbrutet verktyg',
  toolResult: 'Resultat:',
  toolError: 'Fel:',
  toolCancelledReason: 'Orsak till avbrott:',
  approvalAllow: 'Tillåt',
  approvalAlwaysAllow: 'Tillåt alltid',
  approvalDeny: 'Neka',
  approvalAlwaysDeny: 'Neka alltid',
  approvalConfirm: 'Bekräfta',
  approvalBack: 'Tillbaka',
  approvalApprovedResult: 'Godkänt av användaren',
  approvalDeniedResult: 'Användaren nekade verktygskörningen',
  logout: 'Logga ut',
  loginOrCreateAccount: 'Logga in / Skapa konto',
  newChat: 'Ny chatt',
  untitledChat: 'Namnlös chatt',
  previousChats: 'Tidigare chattar',
  openChat: 'Öppna chatten {title}',
  moreActionsForChat: 'Fler åtgärder för {title}',
  chatActions: 'Chattåtgärder',
  closeChatActions: 'Stäng chattåtgärder',
  deleteChatQuestion: 'Ta bort chatten?',
  deleteChatDescription: 'Chatten ”{title}” tas bort permanent.',
  deleteChat: 'Ta bort chatten',
  keepChat: 'Behåll chatten',
  delete: 'Ta bort',
  deleting: 'Tar bort…',
  chatDeleteFailed: 'Det gick inte att ta bort chatten. Försök igen.',
  settingsDescription: 'Anpassa hur assistenten fungerar för dig.',
  settingsDesktopDescription: 'Anpassa hur assistenten svarar dig.',
  personalization: 'Personalisering',
  personalizationDescription: 'Anpassa instruktionerna som assistenten följer i varje svar.',
  languageAndRegion: 'Språk och region',
  languageAndRegionDescription: 'Välj språk och tidszon.',
  memories: 'Minnen',
  memoriesDescription: 'Visa, redigera eller ta bort det assistenten minns om dig.',
  account: 'Konto',
  accountDescription: 'Hantera kontot och permanent borttagning av dina uppgifter.',
  backToSettings: 'Tillbaka till inställningar',
  closeSettings: 'Stäng inställningar',
  settingsCategories: 'Inställningskategorier',
  yourSettings: 'Dina inställningar',
  dataAndAccount: 'Data och konto',
  viewAndManageMemories: 'Visa och hantera det assistenten minns',
  loginToUseMemories: 'Logga in för att använda minnen',
  manageOrDeleteAccount: 'Hantera eller ta bort kontot',
  unsavedChanges: 'Du har osparade ändringar',
  unsavedCloseDescription: 'Om du stänger inställningarna försvinner ändringarna på den här sidan.',
  unsavedBackDescription: 'Om du går tillbaka försvinner ändringarna på den här sidan.',
  continueEditing: 'Fortsätt redigera',
  discardChanges: 'Kasta ändringar',
  saveChanges: 'Spara ändringar',
  localSettingsNote: 'Sparas i den här webbläsaren. Logga in för att spara på ditt konto.',
  personality: 'Personlighet',
  personalityHelp: 'Egna instruktioner som assistenten följer i varje svar',
  personalityPlaceholder:
    'T.ex. Svara kort och konkret. Jag bor i Göteborg och gillar vegetarisk mat.',
  timezone: 'Tidszon',
  searchTimezone: 'Sök tidszon…',
  automaticBrowser: 'Automatisk (webbläsarens)',
  saved: 'Sparat {date}',
  addMemory: 'Lägg till minne',
  newMemory: 'Nytt minne',
  memoryPlaceholder: 'Till exempel: Jag föredrar korta, konkreta svar.',
  editMemory: 'Redigera minne',
  saveMemory: 'Spara minne',
  deleteMemory: 'Ta bort minne',
  memorySaveFailed: 'Kunde inte spara minnet. Försök igen.',
  memoryLimitReached: 'Du kan spara upp till 50 minnen. Ta bort ett innan du lägger till ett nytt.',
  memoryInvalid: 'Minnen kan inte innehålla länkar. Ta bort länken och försök igen.',
  memoryDeleteFailed: 'Kunde inte ta bort minnet. Försök igen.',
  memoryLoadFailed: 'Kunde inte hämta minnen.',
  loadingMemories: 'Hämtar minnen…',
  emptyMemories:
    'Assistenten sparar minnen om dig medan ni pratar — vad du gillar, var du bor, vad du arbetar med. Du ser, redigerar och tar bort dem här.',
  deleteAccountHelp:
    'Radera kontot och alla tillhörande chattar, minnen och inställningar permanent.',
  deleteAccount: 'Ta bort konto',
  deleteAccountQuestion: 'Ta bort kontot permanent?',
  deleteAccountDescription:
    'Alla chattar, meddelanden, minnen, inställningar och inloggningsuppgifter raderas. Åtgärden kan inte ångras.',
  deleteAccountConfirm: 'Ja, ta bort mitt konto',
  accountDeleteFailed: 'Kontot kunde inte tas bort. Ingenting har raderats — försök igen.',
  logoutEverywhereTitle: 'Alla enheter',
  logoutEverywhereHelp:
    'Logga ut på alla enheter och webbläsare där ditt konto är öppet, även den här.',
  logoutEverywhere: 'Logga ut överallt',
  logoutEverywhereQuestion: 'Logga ut på alla enheter?',
  logoutEverywhereDescription:
    'Du behöver logga in igen på alla enheter och webbläsare, även den här. Dina chattar och inställningar finns kvar som de är.',
  loggingOut: 'Loggar ut…',
  logoutEverywhereFailed:
    'Vi kunde inte bekräfta att du loggades ut överallt. Försök igen, eller kontrollera på en annan enhet om du fortfarande är inloggad.',
  settingsSaveFailed: 'Kunde inte spara inställningarna. Försök igen.',
  customInstructions: 'Anpassade instruktioner',
  notSet: 'Inte inställt',
  automaticLanguage: 'Automatiskt språk',
  automaticTimezone: 'automatisk tidszon',
  appLanguage: 'Appspråk',
  appLanguageHelp:
    'Styr hela appens gränssnitt och datum. Assistentens svar fortsätter att följa språket du skriver på.',
  automaticBrowserLanguage: 'Automatiskt (webbläsarens språk)',
  previousLanguageChoice: 'Tidigare val: {language} ({locale})',
  previousLanguageChoiceCode: 'Tidigare val ({locale})',
  canvasCopyLink: 'Kopiera länk',
  canvasLinkCopied: 'Länken har kopierats',
  actionUpdatedWithEdits: 'Uppdaterad med dina ändringar',
  activityStepsDone: 'one:steg klart|other:steg klara',
  activityResultsCount: 'one:träff|other:träffar',
  canvasCopyLinkFailed: 'Det gick inte att kopiera länken',
  canvasOpenInAgent: 'Öppna i {agent}',
  canvasExpand: 'Expandera',
  canvasExitFullView: 'Lämna helvy',
  webSourceUnread:
    'Länkad i det här svaret. Poneva har inte läst sidan, så det finns inget att visa här.',
  webSourceOpenOriginal: 'Öppna originalet',
  toolProgressSettings: 'Ändrar dina inställningar…',
  toolProgressAgent: 'Skapar agenten…',
  toolProgressConnections: 'Hämtar kopplingsalternativ…',
  toolProgressResult: 'Förbereder ditt resultat…',
  toolProgressClarification: 'Förbereder ett förtydligande…',
  toolProgressKnowledge: 'Förbereder ett förslag på kunskapsuppdatering…',
  toolProgressQuestion: 'Förbereder en fråga till dig…',
  toolProgressSkill: 'Formar din Skill…',
  toolErrorSettings: 'Dina inställningar ändrades inte.',
  toolErrorAgent: 'Agenten kunde inte skapas.',
  toolErrorConnections: 'Kopplingsalternativen kunde inte läsas in.',
  toolErrorResult: 'Resultatet sparades inte.',
  toolErrorClarification: 'Förtydligandet kunde inte förberedas.',
  toolErrorKnowledge: 'Förslaget på kunskapsuppdatering kunde inte förberedas.',
  toolErrorQuestion: 'Frågan kunde inte förberedas.',
  toolErrorSkill: 'Skill-utkastet kunde inte sparas.',
  toolErrorOpenSettings: 'Öppna Inställningar',
  toolErrorOpenAgents: 'Öppna Agenter',
  toolErrorOpenConnections: 'Öppna Anslutningar',
  toolStepIncomplete: 'Det här steget slutfördes inte.',
  toolEarlierAttemptsFailed:
    'one:tidigare försök gick inte igenom|other:tidigare försök gick inte igenom',
} satisfies AppCopy;

export const APP_COPY = {
  bg: bgAppCopy,
  hr: hrAppCopy,
  cs: csAppCopy,
  da: daAppCopy,
  nl: nlAppCopy,
  en: englishAppCopy,
  et: etAppCopy,
  fi: fiAppCopy,
  fr: frAppCopy,
  de: deAppCopy,
  el: elAppCopy,
  hu: huAppCopy,
  ga: gaAppCopy,
  it: itAppCopy,
  lv: lvAppCopy,
  lt: ltAppCopy,
  mt: mtAppCopy,
  pl: plAppCopy,
  pt: ptAppCopy,
  ro: roAppCopy,
  sk: skAppCopy,
  sl: slAppCopy,
  es: esAppCopy,
  sv: swedishAppCopy,
} satisfies Record<EuAppLanguage, AppCopy>;
